import * as PATIENT from '../constants/patient';


export default {
  [PATIENT.MUTATE_LIST_PATIENT]: (state, data) => {
    state.list = data;
  },

  [PATIENT.MUTATE_PATIENT]: (state, patient) => {
    state.patient = patient;
  }
}


// WEBPACK FOOTER //
// ./src/store/patient/mutations.js